var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCargo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 242.036,
    height: 153.836,
    viewBox: "0 0 242.036 153.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cargo",
    transform: "translate(-6.954 -16.37)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 121.018,
    cy: 3.242,
    rx: 121.018,
    ry: 3.242,
    transform: "translate(6.954 113.391)",
    fill: "#ffe200",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    "data-name": "Group 1454",
    transform: "translate(30.727 26.024)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 38.59,
    height: 21.302,
    transform: "translate(0 66.375)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 11.731,
    height: 2.47,
    transform: "translate(13.584 70.079)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 8.798,
    height: 1.852,
    transform: "translate(15.05 70.388)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 38.59,
    height: 21.302,
    transform: "translate(39.207 66.375)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 11.731,
    height: 2.47,
    transform: "translate(52.791 70.079)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    width: 8.798,
    height: 1.852,
    transform: "translate(54.257 70.388)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_587",
    "data-name": "Rectangle 587",
    width: 38.59,
    height: 21.302,
    transform: "translate(0 44.456)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    width: 11.731,
    height: 2.47,
    transform: "translate(13.584 48.16)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_589",
    "data-name": "Rectangle 589",
    width: 8.798,
    height: 1.852,
    transform: "translate(15.05 48.469)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 38.59,
    height: 21.302,
    transform: "translate(39.207 44.456)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    width: 11.731,
    height: 2.47,
    transform: "translate(52.791 48.16)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_592",
    "data-name": "Rectangle 592",
    width: 8.798,
    height: 1.852,
    transform: "translate(54.257 48.469)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 38.59,
    height: 21.302,
    transform: "translate(0 22.228)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 11.731,
    height: 2.47,
    transform: "translate(13.584 25.932)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 8.798,
    height: 1.852,
    transform: "translate(15.05 26.241)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 38.59,
    height: 21.302,
    transform: "translate(39.207 22.228)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 11.731,
    height: 2.47,
    transform: "translate(52.791 25.932)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    width: 8.798,
    height: 1.852,
    transform: "translate(54.257 26.241)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 38.59,
    height: 21.302,
    transform: "translate(39.207)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 11.731,
    height: 2.47,
    transform: "translate(52.791 3.705)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 8.798,
    height: 1.852,
    transform: "translate(54.257 4.013)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1455",
    "data-name": "Group 1455",
    transform: "translate(109.142 25.715)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 38.59,
    height: 21.302,
    transform: "translate(0 66.375)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 11.731,
    height: 2.47,
    transform: "translate(13.584 70.079)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    width: 8.798,
    height: 1.852,
    transform: "translate(15.05 70.388)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    width: 38.59,
    height: 21.302,
    transform: "translate(39.207 66.375)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    width: 11.731,
    height: 2.47,
    transform: "translate(52.791 70.079)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 8.798,
    height: 1.852,
    transform: "translate(54.257 70.388)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    width: 38.59,
    height: 21.302,
    transform: "translate(0 44.456)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 11.731,
    height: 2.47,
    transform: "translate(13.584 48.16)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 8.798,
    height: 1.852,
    transform: "translate(15.05 48.469)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 38.59,
    height: 21.302,
    transform: "translate(39.207 44.456)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    width: 11.731,
    height: 2.47,
    transform: "translate(52.791 48.16)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 8.798,
    height: 1.852,
    transform: "translate(54.257 48.469)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    width: 38.59,
    height: 21.302,
    transform: "translate(0 22.228)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 11.731,
    height: 2.47,
    transform: "translate(13.584 25.932)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 8.798,
    height: 1.852,
    transform: "translate(15.05 26.241)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 38.59,
    height: 21.302,
    transform: "translate(39.207 22.228)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 11.731,
    height: 2.47,
    transform: "translate(52.791 25.932)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 8.798,
    height: 1.852,
    transform: "translate(54.257 26.241)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 38.59,
    height: 21.302,
    transform: "translate(39.207)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    width: 11.731,
    height: 2.47,
    transform: "translate(52.791 3.705)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 8.798,
    height: 1.852,
    transform: "translate(54.257 4.013)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M854.375,124.4s-25.991-1.568-22.935,16.646a4.426,4.426,0,0,0,2.309,4.68s.046-1.349,2.667-.889a12.192,12.192,0,0,0,2.825.136,5.883,5.883,0,0,0,3.451-1.426h0s7.307-3.019,10.148-14.96c0,0,2.1-2.606,2.019-3.275l-4.387,1.874s1.5,3.164.309,5.795c0,0-.142-5.68-.984-5.557-.17.028-2.278,1.1-2.278,1.1s2.578,5.511.633,9.518c0,0,.738-6.792-1.439-9.12l-3.087,1.8s3.013,5.693.969,10.339c0,0,.525-7.125-1.621-9.9l-2.8,2.183s2.831,5.613,1.105,9.465c0,0-.225-8.3-1.71-8.922a17.2,17.2,0,0,0-2.822,3.044s1.939,4.075.735,6.224c0,0-.738-5.526-1.343-5.557,0,0-2.439,3.661-2.692,6.174a13.309,13.309,0,0,1,2.1-6.523,7.339,7.339,0,0,0-3.735,1.936s.38-2.59,4.337-2.816c0,0,2.016-2.778,2.553-2.948,0,0-3.933-.327-6.319.729,0,0,2.1-2.442,7.042-1.331l2.763-2.257s-5.18-.707-7.378.074c0,0,2.529-2.161,8.122-.583l3.013-1.784a27.587,27.587,0,0,0-7.048-.617s2.778-1.5,7.931.127l2.161-.966s-3.235-.636-4.183-.738-1-.361-1-.361a11.222,11.222,0,0,1,6.079.676S854.456,124.691,854.375,124.4Z",
    transform: "translate(-646.491 -100.41)",
    fill: "#ffe200",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M779.007,139.456s-11.731-.71-10.358,7.523a2.009,2.009,0,0,0,1.04,2.115s.022-.617,1.207-.4a5.407,5.407,0,0,0,1.275.062,2.647,2.647,0,0,0,1.559-.645h0s3.3-1.361,4.587-6.758c0,0,.948-1.179.911-1.482l-1.982.846a3.553,3.553,0,0,1,.145,2.621s-.065-2.569-.444-2.507c-.077,0-1.031.494-1.031.494s1.167,2.491.287,4.3c0,0,.333-3.069-.651-4.121l-1.4.815s1.365,2.572.438,4.671c0,0,.238-3.22-.732-4.473l-1.263.985s1.278,2.538.5,4.279c0,0-.1-3.751-.775-4.032a7.736,7.736,0,0,0-1.275,1.377s.877,1.852.333,2.809c0,0-.333-2.5-.617-2.507a8.377,8.377,0,0,0-1.216,2.779,6.035,6.035,0,0,1,.951-2.948,3.322,3.322,0,0,0-1.689.874s.173-1.167,1.96-1.272a8.433,8.433,0,0,1,1.155-1.331,7.237,7.237,0,0,0-2.856.33s.948-1.105,3.183-.6l1.235-1.019a10.652,10.652,0,0,0-3.334.034s1.142-.976,3.671-.265l1.358-.812a12.209,12.209,0,0,0-3.186-.275,4.874,4.874,0,0,1,3.584.056l.972-.435s-1.463-.29-1.892-.333-.451-.164-.451-.164a5.059,5.059,0,0,1,2.748.309A12.486,12.486,0,0,0,779.007,139.456Z",
    transform: "translate(-595.797 -123.071)",
    fill: "#ffe200",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 12.414,
    cy: 2.099,
    rx: 12.414,
    ry: 2.099,
    transform: "translate(43.687 163.99)",
    fill: "#ffe200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M243.115,738.4a3.6,3.6,0,0,0,1.182-1.788,1.594,1.594,0,0,0-.827-1.818c-.759-.29-1.571.238-2.186.769a2.918,2.918,0,0,1-2.124,1.025,3.242,3.242,0,0,0,1-3.029,1.271,1.271,0,0,0-.278-.617c-.423-.451-1.186-.259-1.692.1-1.605,1.13-2.053,3.313-2.062,5.273a9.92,9.92,0,0,1-.028-2.161,2.227,2.227,0,0,0-.818-1.923,2.439,2.439,0,0,0-1.235-.29,2.564,2.564,0,0,0-2.016.574,1.99,1.99,0,0,0,.077,2.47,7.856,7.856,0,0,0,2.09,1.673,4.632,4.632,0,0,1,1.491,1.423,1.273,1.273,0,0,1,.111.256h4.526A12.585,12.585,0,0,0,243.115,738.4Z",
    transform: "translate(-181.88 -575.742)",
    fill: "#ffe200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M720.57,463.648a1.4,1.4,0,0,0-.769-1.105,1.436,1.436,0,0,0-1.9.8l-6.857,14.427-1.544,56.8h2.47L712.9,477.9l7.545-13.355A1.466,1.466,0,0,0,720.57,463.648Z",
    transform: "translate(-512.219 -388.924)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M532.756,721.756a37.193,37.193,0,0,1-5.176,4.726,1.05,1.05,0,0,1-.1.142,1.5,1.5,0,0,1-.675.426h0a34.145,34.145,0,0,1-19.907,6.427h-135c-15.468-2-24.906-4.652-24.906-7.564,0-2.257,5.667-4.359,15.424-6.119q1.517-.278,3.165-.537,1.014-.161,2.075-.309l1.2-.176q1.336-.191,2.743-.374h.076l.982-.124q1.245-.162,2.541-.309l.629-.071,1.6-.179q1.562-.176,3.192-.337,1.353-.133,2.75-.265c9.443-.88,20.33-1.544,32.176-1.973L418.94,715l1.139-.031,2.406-.068.965-.025,1.014-.025.722-.016,3.388-.068,1.741-.031h.356q6.175-.093,12.581-.1c8.441,0,16.627.126,24.428.367h0q6.718.2,13.025.518h.039c12.124.6,22.977,1.482,31.958,2.578l.165.022q3.458.421,6.536.889c1.927.29,3.737.6,5.416.908.582.108,1.147.219,1.7.327l.14.031C528.983,720.753,531.026,721.234,532.756,721.756Z",
    transform: "translate(-284.543 -563.274)",
    fill: "#ffe200",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 9.262,
    cy: 9.262,
    r: 9.262,
    transform: "translate(170.577 146.733)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 9.262,
    cy: 9.262,
    r: 9.262,
    transform: "translate(170.577 146.733)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 5.866,
    cy: 5.866,
    r: 5.866,
    transform: "translate(173.973 150.129)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_159",
    "data-name": "Ellipse 159",
    cx: 5.866,
    cy: 5.866,
    r: 5.866,
    transform: "translate(173.973 150.129)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M630,680.556l6.076,13.738a1.179,1.179,0,0,0,2.14.043l7.221-14.707Z",
    transform: "translate(-457.262 -539.072)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M630,680.556l6.076,13.738a1.179,1.179,0,0,0,2.14.043l7.221-14.707Z",
    transform: "translate(-457.262 -539.072)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 9.262,
    cy: 9.262,
    r: 9.262,
    transform: "translate(112.847 146.733)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 9.262,
    cy: 9.262,
    r: 9.262,
    transform: "translate(112.847 146.733)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 5.866,
    cy: 5.866,
    r: 5.866,
    transform: "translate(116.242 150.129)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 5.866,
    cy: 5.866,
    r: 5.866,
    transform: "translate(116.242 150.129)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M443,680.556l6.075,13.738a1.179,1.179,0,0,0,2.139.043l7.221-14.707Z",
    transform: "translate(-327.992 -539.072)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M443,680.556l6.075,13.738a1.179,1.179,0,0,0,2.139.043l7.221-14.707Z",
    transform: "translate(-327.992 -539.072)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M729.027,465.648a1.4,1.4,0,0,0-.768-1.105,1.435,1.435,0,0,0-1.9.8l-5.313,13.191L719.5,537.811h2.47l.926-59.147,6-12.12A1.465,1.465,0,0,0,729.027,465.648Z",
    transform: "translate(-519.132 -390.307)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M368.5,549.28l8.335-5.248,89.992-.772,2.315,6.02Z",
    transform: "translate(-267.848 -406.406)",
    fill: "#ffe200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M368.5,566.1v-5.557l102.272-.988-.1,3.767H370.352V566.1Z",
    transform: "translate(-267.848 -417.674)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 9.262,
    cy: 9.262,
    r: 9.262,
    transform: "translate(104.357 149.974)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 5.866,
    cy: 5.866,
    r: 5.866,
    transform: "translate(107.753 153.37)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M415.5,691.056l6.075,13.738a1.179,1.179,0,0,0,2.139.043l7.221-14.707Z",
    transform: "translate(-308.982 -546.33)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 9.262,
    cy: 9.262,
    r: 9.262,
    transform: "translate(176.288 149.974)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    cx: 5.866,
    cy: 5.866,
    r: 5.866,
    transform: "translate(179.684 153.37)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M648.5,691.056l6.076,13.738a1.179,1.179,0,0,0,2.139.043l7.221-14.707Z",
    transform: "translate(-470.051 -546.33)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    width: 38.59,
    height: 21.302,
    transform: "translate(112.229 118.639)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 11.731,
    height: 2.47,
    transform: "translate(125.813 122.344)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    width: 8.798,
    height: 1.852,
    transform: "translate(127.279 122.653)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 38.59,
    height: 21.302,
    transform: "translate(151.436 118.639)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    width: 11.731,
    height: 2.47,
    transform: "translate(165.02 122.344)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 8.798,
    height: 1.852,
    transform: "translate(166.486 122.653)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    width: 38.59,
    height: 21.302,
    transform: "translate(112.229 96.72)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 11.731,
    height: 2.47,
    transform: "translate(125.813 100.425)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 8.798,
    height: 1.852,
    transform: "translate(127.279 100.733)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 38.59,
    height: 21.302,
    transform: "translate(151.436 96.72)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 11.731,
    height: 2.47,
    transform: "translate(165.02 100.425)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 8.798,
    height: 1.852,
    transform: "translate(166.486 100.733)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 38.59,
    height: 21.302,
    transform: "translate(112.229 74.492)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 11.731,
    height: 2.47,
    transform: "translate(125.813 78.197)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 8.798,
    height: 1.852,
    transform: "translate(127.279 78.506)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 38.59,
    height: 21.302,
    transform: "translate(151.436 74.492)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 11.731,
    height: 2.47,
    transform: "translate(165.02 78.197)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    width: 8.798,
    height: 1.852,
    transform: "translate(166.486 78.506)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    width: 38.59,
    height: 21.302,
    transform: "translate(151.436 52.265)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 11.731,
    height: 2.47,
    transform: "translate(165.02 55.969)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 8.798,
    height: 1.852,
    transform: "translate(166.486 56.278)",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargo);
export default __webpack_public_path__ + "static/media/cargo.168b470b4738c29aedeb3db6d7d5c5b1.svg";
export { ForwardRef as ReactComponent };